import { colors } from 'assets/styled/tokens';
import { css } from 'styled-components';

const lightOutline = () => css`
  background: white;
  color: ${colors.carbon};
  border: 1px solid ${colors.whiteGray};
`;

export { lightOutline };
